import { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router';

import { SoftwareEscrowContextProvider, SoftwareEscrowOnboardingContextProvider } from 'src/context/software-escrow';
import { getEscrowOnboardingStep } from 'src/utils/escrowOnboardingLocalStorage';
import { SoftwareOnboardingLayout } from 'src/components/SoftwareOnboarding';

import Footer from './Footer';
import Header from './Header';

const getOnboardingUrl = (escrowId: string) => {
  const onboardingStep = getEscrowOnboardingStep(escrowId) || 'members';

  if (onboardingStep) return `/software-escrows/onboarding/${escrowId}/${onboardingStep}`;

  return `/software-escrows/${escrowId}`;
};

const Layout = () => {
  const { id = '' } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const onboardingUrl = getOnboardingUrl(id);
    navigate(onboardingUrl, { replace: true });
  }, [id]);

  return (
    <SoftwareEscrowContextProvider>
      <SoftwareEscrowOnboardingContextProvider>
        <SoftwareOnboardingLayout>
          <Header />
          <Outlet />
          <Footer />
        </SoftwareOnboardingLayout>
      </SoftwareEscrowOnboardingContextProvider>
    </SoftwareEscrowContextProvider>
  );
};

export default Layout;
